import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_PROJECT_V2, GET_PROJECT_V2_SUCCESS, GET_PROJECT_V2_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* getProjectV2({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/client/${payload?.data?.clientId}/projects`,
      method: 'GET',
      params: payload?.urlParams,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_PROJECT_V2_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);

      yield put({
        type: GET_PROJECT_V2_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_PROJECT_V2_ERROR, payload: error });
  }
}

export function* watchGetProjectV2() {
  yield takeEvery(GET_PROJECT_V2, getProjectV2);
}

function* getProjectV2Saga() {
  yield all([fork(watchGetProjectV2)]);
}

export default getProjectV2Saga;
